export default {
    checkpoints: ( state ) => {
        return state.checkpoints;
    }
}